namespace Gamification.Gamification {
    export interface ChecklistNodiForm {
        IdChecklist: Serenity.IntegerEditor;
        IdNodo: Serenity.IntegerEditor;
    }

    export class ChecklistNodiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ChecklistNodi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChecklistNodiForm.init)  {
                ChecklistNodiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(ChecklistNodiForm, [
                    'IdChecklist', w0,
                    'IdNodo', w0
                ]);
            }
        }
    }
}
